<template>
	<div class="row justify-content-center no-gutters">
		<div v-if="loaded" v-for="licence in filteredLicences" class="col col-lg-3 col-md-4 col-sm-6 col-12">
			<div class="content-item-wrap" v-bind:style="itemStyle" ref="item">
				<a :href="buildLinkUrl(licence)" :class="{ 'disabled': editing }" v-on:click="checkEditing($event)" :target="buildTarget(licence)">
					<div class="content-item d-flex flex-column h-100" :class="[licence.slug, { editing: editing }]">
						<div class="content-icon flex-fill" v-bind:style="{backgroundImage: iconPath(licence.icon)}"></div>
						<div class="content-title" v-html="licence.title"></div>
						<div class="edit-overlay d-flex justify-content-center align-items-center" v-if="editing">	
							<button class="btn green outline " v-if="licence.hidden" v-on:click="toggleEditItem(licence)">Prikaži gradivo</button>
							<button class="btn red outline" v-else v-on:click="toggleEditItem(licence)">Skrij gradivo</button>
						</div>
					</div>
				</a>
			</div>
		</div>
		<div v-if="loaded && !editing" class="col col-lg-3 col-md-4 col-sm-6 col-12">
			<div class="content-item-wrap" v-bind:style="itemStyle" ref="add">
				<a :href="route('aktivacijska-koda')">
					<div class="content-item add-content-item d-flex flex-column h-100">
						<div class="content-icon flex-fill" v-bind:style="{backgroundImage: 'url(/images/icon_add_content.svg)'}"></div>
						<div class="content-title">
							Dodaj gradivo z aktivacijsko kodo
						</div>
						<div class="edit-overlay" v-if="editing"></div>
					</div>
				</a>
			</div>
		</div>
		<div v-if="loaded && !emptyCollection" class="col col-lg-3 col-md-4 col-sm-6 col-12">
			<div class="content-item-wrap" v-bind:style="itemStyle">
				<div class="content-item add-content-item d-flex flex-column h-100" v-on:click="toggleEditMode">
					<div class="content-icon flex-fill" v-bind:style="{ backgroundImage: editBackground }"></div>
					<div class="content-title">
						Uredi iZbirko
					</div>
				</div>
			</div>
		</div>
		<div class="col col-12 hidden-warning" v-if="hasHidden">
			Vaša iZbirka vsebuje skrita gradiva.
		</div>
		<div v-if="!loaded" class="col col-12">
			<spinner></spinner>
		</div>
	</div>
</template>

<script>
	import libraryItem from '../library-item'
	import popupZzv from './PopupZzv.vue'
	// import popupFiniKviz from './PopupFiniKviz.vue'
	// import popupMaraton from "./PopupMaraton.vue";

	export default {
		mixins: [libraryItem],
		data() {
			return {
				editing: false
			}
		},
		mounted: function () {
			this.loadLicences(null, 'order');
			this.loadPopups();
		},
		methods: {
			loadPopups() {
				axios.get(this.route('status')).then((response) => {
					if (response.data.status == 'student') {
						this.$root.$emit('add-popup', popupZzv);
					}
					if (response.data.status == 'teacher') {
						// this.$root.$emit('add-popup', popupFiniKviz);
						// this.$nextTick(() => {
						// 	this.$root.$emit('add-popup', popupMaraton);
						// })
					}
				}, (reason) => {
					console.error(reason);
				});

			},
			buildLinkUrl(licence) {
				if (licence.url) {
					return this.route('vsebine', licence.credit_id);
				} else {
					return this.route('izbirka', licence.slug);
				}
			},
			buildTarget(licence) {
				return licence.url ? '_blank' : '_self';
			},
			toggleEditMode() {
				this.editing = !this.editing;
				if (!this.editing) {
					this.postEditing();
				}
			},
			toggleEditItem(item) {
				this.$set(item, 'hidden', !item.hidden);
			},
			checkEditing(event) {
				if (this.editing) {
					event.preventDefault();
					return false;
				} else {
					return true;
				}
			},
			postEditing() {
				let hide = [];
				for(let i = 0; i < this.licences.length; i++) {
					let licence = this.licences[i];
					if (licence.hidden) hide.push(licence.id);
				}
				axios.post(this.route('api-licences'), {
					hide: hide
				}).then((response) => {
					// console.log(response);
				});
			}
		},
		computed: {
			filteredLicences() {
				if (this.licences == null) return [];
				return this.licences.filter((item) => {
					if (item.hidden && !this.editing) return false;
					return true;
				});
			},
			editBackground() {
				return this.editing ? 'url(/images/icon_edit_content_confirm.svg)' : 'url(/images/icon_edit_content.svg)';
			},
			emptyCollection() {
				return this.licences.length == 0;
			},
			hasHidden() {
				return this.licences && this.licences.length != this.filteredLicences.length;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Collection.vue